import type { MessagingChannelsCopy } from './types';

export const HI: MessagingChannelsCopy = {
  title: 'मैसेजिंग',
  description:
    'जिन चैट ऐप्स का आप पहले से इस्तेमाल करते हैं, उन्हीं से IMAI से बात करें। एक बार कनेक्ट करें, फिर वहीं IMAI को मैसेज करें।',
  privacy:
    'आपके कनेक्ट किए गए खातों से आए संदेश इस वर्कस्पेस में आपके नाम से चलते हैं और आपके क्रेडिट इस्तेमाल करते हैं।',
  loading: 'मैसेजिंग चैनल लोड हो रहे हैं',
  unavailable: 'अभी उपलब्ध नहीं',
  unavailableNote: '{channel} अभी IMAI के लिए सेट अप नहीं है।',
  connectedBadge: 'कनेक्टेड',
  cancel: 'रद्द करें',

  phoneTitle: 'फ़ोन नंबर',
  phoneNote: 'अपने फ़ोन नंबर से WhatsApp या iMessage जोड़ें।',
  phoneUnavailableNote: 'IMAI को टेक्स्ट करना अभी सेट अप नहीं है।',
  addNumber: 'नंबर जोड़ें',
  countryLabel: 'देश कोड',
  countrySearch: 'देश या कोड खोजें…',
  countryEmpty: 'कोई देश नहीं मिला।',
  numberLabel: 'फ़ोन नंबर',
  numberPlaceholder: 'फ़ोन नंबर',
  numberHint: 'आपका देश सूची में नहीं है? + से शुरू करके पूरा नंबर लिखें।',
  continueActivation: 'जारी रखें',
  editNumber: 'नंबर बदलें',
  activateQr: 'जुड़ने के लिए स्कैन करें और भेजें।',
  activateTitle: 'WhatsApp पर एक मैसेज भेजें',
  activateHint: 'बटन पर टैप करें और पहले से भरा हुआ मैसेज भेज दें।',
  activateSentFrom: 'इसे {number} से भेजें।',
  activateButton: '{channel} खोलें',
  activateManual: 'या WhatsApp पर {number} को {message} भेजें।',
  activateWaiting: 'आपके मैसेज का इंतज़ार है। {time} में समय-सीमा खत्म होगी।',
  startAgain: 'फिर से शुरू करें',
  verifiedBadge: 'सत्यापित',
  verifiedOn: '{date} को सत्यापित',
  change: 'बदलें',
  changeAria: 'फ़ोन नंबर {number} बदलें',
  remove: 'हटाएं',
  removeAria: 'फ़ोन नंबर {number} हटाएं',
  messageImai: 'IMAI को मैसेज करें',
  messageImaiAria: '{channel} पर IMAI को मैसेज करें',
  removeTitle: '{number} हटाएं?',
  removeDescription:
    'IMAI इस नंबर को iMessage और WhatsApp पर जवाब देना बंद कर देगा। आप इसे कभी भी फिर से जोड़ सकते हैं।',
  removeError: 'नंबर नहीं हटाया जा सका। फिर से कोशिश करें।',

  errorInvalidNumber: 'एरिया कोड के साथ एक सही फ़ोन नंबर डालें।',
  errorNumberTaken:
    'यह नंबर पहले से किसी दूसरे IMAI खाते में इस्तेमाल हो रहा है।',
  errorRateLimited: 'बहुत सारे प्रयास। थोड़ी देर रुकें, फिर से कोशिश करें।',
  errorChannelUnavailable: 'यह विकल्प अभी उपलब्ध नहीं है। दूसरा विकल्प चुनें।',
  errorSendFailed: 'सत्यापन शुरू नहीं हो सका। फिर से कोशिश करें।',
  errorActivationExpired:
    'इस एक्टिवेशन की समय-सीमा खत्म हो गई। फिर से शुरू करें।',

  noteSlack: 'अपने Slack वर्कस्पेस से IMAI को मैसेज करें।',
  noteTeams: 'Microsoft Teams से IMAI को मैसेज करें।',
  noteTelegram: 'Telegram पर IMAI बॉट से चैट करें।',
  connect: 'कनेक्ट करें',
  connectAria: '{channel} कनेक्ट करें',
  connectError: '{channel} कनेक्ट करना शुरू नहीं हो सका। फिर से कोशिश करें।',
  connectedOn: '{date} को कनेक्ट किया गया',
  accountFallback: 'आपका {channel} खाता',
  installSlack: 'IMAI को अपने वर्कस्पेस में जोड़ें',
  installTeams: 'IMAI को Teams में जोड़ें',
  openTelegram: 'Telegram में खोलें',
  disconnect: 'डिस्कनेक्ट करें',
  disconnectAria: '{channel} से {account} को डिस्कनेक्ट करें',
  disconnectError: '{channel} डिस्कनेक्ट नहीं हो सका। फिर से कोशिश करें।',
  disconnectTitle: '{channel} डिस्कनेक्ट करें?',
  disconnectDescription:
    '{account} के संदेश अब IMAI तक नहीं पहुंचेंगे। आप इसे कभी भी फिर से कनेक्ट कर सकते हैं।',

  toastConnected: '{channel} कनेक्ट हो गया',
  toastConnectedGeneric: 'खाता कनेक्ट हो गया',
  toastErrorExpired:
    'साइन-इन में बहुत समय लगा। फिर से कनेक्ट करने की कोशिश करें।',
  toastErrorInvalidState:
    'यह साइन-इन लिंक अब मान्य नहीं है। फिर से कोशिश करें।',
  toastErrorAccountTaken:
    'यह खाता पहले से किसी दूसरे IMAI उपयोगकर्ता से कनेक्ट है।',
  toastErrorNotMember: 'आप अब इस वर्कस्पेस के सदस्य नहीं हैं।',
  toastErrorProvider:
    'साइन-इन पूरा नहीं हुआ। फिर से कनेक्ट करने की कोशिश करें।',
  toastErrorGeneric: 'खाता कनेक्ट नहीं हो सका। फिर से कोशिश करें।',
};
